// Order Management System
export const EDIT_EPRESCRIPTION = 'EDIT_EPRESCRIPTION';
export const PUSH_MED_AT_INDEX_OF = 'PUSH_MED_AT_INDEX_OF';
export const ADD_MEDICINE_TO_LIST = 'ADD_MEDICINE_TO_LIST';
export const DELETE_MEDICINE_FROM_LIST = 'DELETE_MEDICINE_FROM_LIST';
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const MODAL_VISIBLE_TRUE = 'MODAL_VISIBLE_TRUE';
export const MODAL_VISIBLE_FALSE = 'MODAL_VISIBLE_FALSE';
export const ADD_PATIENT_DETAILS = 'ADD_PATIENT_DETAILS';
export const RESET_ORDER_DETAIL = 'RESET_ORDER_DETAIL';
export const MENU_CHANGE = 'MENU_CHANG';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const SET_PARTNERS = 'SET_PARTNERS';
export const ADD_PPRESCRIPTION_URL = 'ADD_PPRESCRIPTION_URL';
export const UPDATE_PPRESCRIPTION = 'UPDATE_PPRESCRIPTION';
export const DELETE_PRESCRIPTION_URL_AT_POSITION = 'DELETE_PRESCRIPTION_URL_AT_POSITION';
export const SET_SPECIALITIES = 'SET_SPECIALITIES';
export const ADD_AILMENT = 'ADD_AILMENT';
export const DELETE_AILMENT = 'DELETE_AILMENT';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const SET_CAREFILL_PRESCRIPTIONS = 'SET_CAREFILL_PRESCRIPTIONS';
export const ADD_CAREFILL_PRESCRIPTIONS = 'ADD_CAREFILL_PRESCRIPTIONS';
export const DELETE_CAREFILL_PRESCRIPTION = 'DELETE_CAREFILL_PRESCRIPTION';

// Refill Management System
export const SET_REFILLS = 'SET_REFILLS';
export const UPDATE_REFILL = 'UPDATE_REFILL';
export const UPDATE_ACTIVE_TAB = 'UPDATE_ACTIVE_TAB';
export const SET_DATE_CALLS = 'SET_DATE_CALLS';

// PACKAGING INVENTORY
export const SET_ORDERS = 'SET_ORDERS';
export const SET_PRESCRIPTION_MEDICINES = 'SET_PRESCRIPTION_MEDICINES';
export const SET_PARTNERS_LIST = 'SET_PARTNERS_LIST';
export const ADD_MED_TO_INVENTORY = 'ADD_MED_TO_INVENTORY';
export const SET_REQUISITION_MED = 'SET_REQUISITION_MED';
export const SET_PATIENT_PACKET = 'SET_PATIENT_PACKET';
export const SET_INVENTORY_MED = 'SET_INVENTORY_MED';
export const CLEAR_PATIENT_PACKET = 'CLEAR_PATIENT_PACKET';
export const CLEAR_PRESCRIPTION_MEDICINES = 'CLEAR_PRESCRIPTION_MEDICINES';
export const CLEAR_INVENTORY_MEDICINES = 'CLEAR_INVENTORY_MEDICINES';
export const EDIT_MED_TO_INVENTORY = 'EDIT_MED_TO_INVENTORY';
export const DELETE_MED_FROM_INVENTORY = 'DELETE_MED_FROM_INVENTORY';
export const SET_COMPARED_MEDS = 'SET_COMPARED_MEDS';
export const UPDATE_COMPARED_MEDS = 'UPDATE_COMPARED_MEDS';
export const SET_EXPIRY_DATE = 'SET_EXPIRY_DATE';

// FETCH ORDER
export const SET_FETCH_ORDER = 'SET_FETCH_ORDER';
export const UPDATE_ORDER = 'UPDATE_ORDER';
export const SET_FETCH_PARTNERS = 'SET_FETCH_PARTNERS';
export const SETCURRENTPAGEANDSIZE = 'SETCURRENTPAGEANDSIZE';

// ORDER DISPATCH
export const SET_OUT_REFILLS = 'SET_OUT_REFILLS';
export const UPDATE_OUT_REFILLS = 'UPDATE_OUT_REFILLS';
export const CLEAR_OUT_REFILLS = 'CLEAR_OUT_REFILLS';

// Edit non rx medicines
export const EDIT_NONRXMEDICINES = 'EDIT_NONRXMEDICINES';
export const ADD_NONRXMEDICINE_TO_LIST = 'ADD_NONRXMEDICINE_TO_LIST';
export const PUSH_NONRXMED_AT_INDEX_OF = 'PUSH_NONRXMED_AT_INDEX_OF';
export const DELETE_NONRXMEDICINE_FROM_LIST = 'DELETE_NONRXMEDICINE_FROM_LIST';



// WEBPACK FOOTER //
// ./src/ActionTypes/ActionTypes.js